__turbopack_context__.v({
  "item": "ProspectFilterMenu-module__1FgazG__item",
  "itemActive": "ProspectFilterMenu-module__1FgazG__itemActive",
  "list": "ProspectFilterMenu-module__1FgazG__list",
  "panel": "ProspectFilterMenu-module__1FgazG__panel",
  "section": "ProspectFilterMenu-module__1FgazG__section",
  "sectionDot": "ProspectFilterMenu-module__1FgazG__sectionDot",
  "sectionTitle": "ProspectFilterMenu-module__1FgazG__sectionTitle",
  "trigger": "ProspectFilterMenu-module__1FgazG__trigger",
  "triggerActive": "ProspectFilterMenu-module__1FgazG__triggerActive",
});
